module.exports = __webpack_public_path__ + "img/sacco3.604886a4.png";